
import moment from 'moment';
import { formatPercentNum, upperFirstConcat } from "@/pages/dashboard/utils/utils";



// 如果值是仅仅首字母大写区分；
export const getBreakDownHeader = (countryType, isSingleTime, type, prefix = "Sum", shareRename = '') => {
  return {
    [countryType]: {
      countryName: upperFirstConcat(countryType).replace("_", " "),
      valueName: (isSingleTime ? type : `${prefix} ${type}`)?.trim(),
      share: shareRename ? shareRename : "Share of ALL",
      date: "DATE",
    }
  }
}

export const defaultSetOtherConfigFunc = ({ opt, module = '', indexGap = 1, getLocalText }) => {
  opt.legend.formatter = (name) => {
    const index = opt?.legend?.data?.findIndex(item => item === name) + indexGap
    const id = module ? `${module}_legend${index}` : `legend${index}`
    return getLocalText(id)
  }
}

export const getOptions = (optionMap: { x: string, legend: Array<{ name: string, key: string }> }, tableMap, fetchData) => {
  const { x, legend } = optionMap
  const result: any = {
    chart: [],
    table: {}
  }
  // 没有数据无需进行多余计算
  if (fetchData?.length <= 0) return result

  result.chart = legend?.map?.(({ name, key }) => {
    const data = fetchData?.map?.((item: any) => ({
      x: item[x],
      y: item[key]
    }))
    return { name, data }
  })

  result.table = {
    option: tableMap?.map((item: any) => ({
      key: item.key,
      align: item.key === 'day' ? 'left' : 'right',
      fixed: 'left',
      width: 100,
      header: item.header ?? item.name,
      render: item.render ?? item.name
    })),
    data: fetchData?.map((item: any) => {
      const keys = tableMap.map((item: any) => item.key)
      const record: any = {}
      keys.forEach((key: any) => {
        record[key] = item[key] || '-'
      })
      return record
    })
  }
  return result
}

export const getRatioText = (num: any, chartPercentDecimal?: number,isNotFloating?:boolean) => {
  const decimal = chartPercentDecimal ? chartPercentDecimal : 1;
  num = Number((num / 1)?.toFixed?.(decimal+2)) / 1
  const status: 'zero' | 'up' | 'down' = (() => {
    if (num === 0) return 'zero'
    if (num > 0) return 'up'
    if (num < 0) return 'down'
    return 'zero'
  })()

  // 兼容之前的写法，所以这里用isNotFloating进行转换
  const ratioNumPercent = formatPercentNum(+num, decimal, !isNotFloating)

  return {
    text: `${ratioNumPercent}`,
    status
  }
}